module.exports = __webpack_public_path__ + "static/enterprise-2-m-a7607d701efb77da5f0637822754fdcb.png";